<template>
  <div class="invite-form nc-form">

    <div class="url">{{ url }}</div>

    <div class="wrapper title-wrapper">
      <label>Назва запрошення</label>
      <input
        v-model="invite.title"
      ></input>
    </div>

    <div class="wrapper roles-wrapper">
      <label>Ролі</label>
      <v-select
          label="Your favorite hobbies"
          chips
          tags
          solo
          clearable
          v-model="roles"
          class="roles"
      >
        <template slot="selection" slot-scope="data">
          <v-chip
            close
            @input="removeRole(data.item)"
            :selected="data.selected"
          >
            {{ data.item }}
          </v-chip>
        </template>
      </v-select>
    </div>

    <div
      class="wrapper email-wrapper"
    >
      <label>Email</label>
      <input
        v-model="invite.email.email"
      ></input>
    </div>

    <div
      v-if="invite.email.email"
      class="wrapper send-notifications-wrapper"
    >
      <label>Сповіщення</label>
      <v-checkbox
        label="Відправляти сповіщення за цією адресою"
        v-model="invite.sendNotifications"
      ></v-checkbox>
    </div>

    <div v-if="invite.email.email">
      <div class="wrapper description-wrapper">
        <label>Шаблон листа</label>
        <v-select
          :items="emailTemplates"
          v-model="invite.email.template"
        ></v-select>
      </div>

      <div class="wrapper subject-wrapper">
        <label>Тема листа</label>
        <input
          v-model="invite.email.subject"
        ></input>
      </div>

      <div class="wrapper description-wrapper">
        <label>Текст листа</label>

        <textarea-autosize
          v-model="invite.email.text"
          ref="description"
        ></textarea-autosize>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'InviteForm',
  props: {
    invite: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      sendEmail: true,
      emailTemplates: ['default', 'v2-invite'],
    };
  },
  computed: {
    urlPrefix() {
      return `${location.origin}/login/invite/`;
    },
    url() {
      return `${this.urlPrefix}${this.invite.id}`;
    },
    roles: {
      get() {
        return Object.keys(this.invite.roles || {});
      },
      set(roles) {
        const rolesObject = {};
        roles.forEach((role) => { rolesObject[role] = true; });
        this.$set(this.invite, 'roles', rolesObject);
      },
    },
  },
  watch: {
    // eslint-disable-next-line
    ['invite.email.email'](val) {
      if (val) {
        this.invite.email.subject = 'Корпорація Наші 2.0: новий дизайн, публічні пости, швидкість, зручність, безпека';
        this.invite.email.text = `${this.url}`;
        this.invite.email.template = 'default';
      } else {
        this.invite.email.subject = null;
        this.invite.email.text = null;
        this.invite.email.template = null;
      }
    },
  },
  methods: {
    removeRole(role) {
      this.$delete(this.invite.roles, role);
    },
  },
};

</script>

<style scoped>

.url {
  border: dashed 1px #ddd;
  width: 100%;
  padding: 10px;
  margin-bottom: 15px;
  background: #f9f9f9;
  font-size: 14px;
  word-break: break-all;
}

textarea {
  outline: none;
  border: solid 1px rgba(0,0,0, .1);
  background: #fff;
  padding: 4px;
  min-height: 100px;
}

.roles-wrapper .roles {
  box-shadow: none;
  border: solid 1px rgba(0,0,0, .1);
}

</style>

<style>
.roles-wrapper .input-group--select__autocomplete {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/InviteForm.vue